<script>
	import { projectSettings } from "../config";
	import { regFormEmail } from "../tealium";
</script>

<a
	title="Email {projectSettings.emailAddress}"
	href="mailto:{projectSettings.emailAddress}"
	on:click={() => regFormEmail(projectSettings.emailAddress)}
	target="_blank"
>
	{projectSettings.emailAddress}
</a>
